<template>
  <v-container class="fill-height" fluid>
    <v-row justify="center" align="center">
      <v-col cols="12" sm="6" md="4">
        <v-card class="pa-4 text-center">
          <v-card-text>
            <v-progress-circular
              v-if="!error"
              :size="50"
              color="primary"
              indeterminate
              class="mb-4"
            />
            <v-icon
              v-else
              color="error"
              size="50"
              class="mb-4"
              :icon="mdiAlertCircle"
            />

            <h3 class="text-h6 mb-2">
              {{ error ? "Erro na Autenticação" : "Processando..." }}
            </h3>

            <p v-if="!error">Finalizando seu login...</p>
            <p v-else class="text-error">
              {{ error }}
            </p>
          </v-card-text>

          <v-card-actions v-if="error">
            <v-btn @click="router.push('/login')" color="primary" block>
              Tentar Novamente
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { mdiAlertCircle } from "@mdi/js";
import { useRouter } from "vue-router";
import { useAuthStore } from "@/stores/auth";
import oauth2Service from "@/services/oauth2";

const router = useRouter();
const authStore = useAuthStore();
const error = ref(null);

onMounted(async () => {
  try {
    // Check for immediate error in URL parameters
    const url = new URL(window.location.href);
    const errorParam = url.searchParams.get("error");
    const errorDescription = url.searchParams.get("error_description");

    if (errorParam) {
      let errorMessage = `Erro de autorização: ${errorParam}`;
      if (errorDescription) {
        errorMessage += ` - ${errorDescription}`;
      }
      throw new Error(errorMessage);
    }

    const tokens = await oauth2Service.handleCallback(window.location.href);

    await authStore.oauthLoginSuccess(tokens);

    router.push("/");
  } catch (err) {
    console.error("OAuth callback error:", err);
    error.value = err.message;
  }
});
</script>
